import {dataHooks} from '@wix/data-hooks'

export const areaSelectorDataHooks = dataHooks<{
  root: {}
  card: {id: string}
}>('area-selector')
